import OnlyIfUserCanAccessDiscoveryPath from "../../Pages/Discovery/components/OnlyIfUserCanAccessDiscoveryPath";
import React from "react";
import { useString as s } from "../StringProvider";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import NewButton from "../NewButton";
import {
  hasPermission,
  isDiscoveryRegisterInterestComplete,
  selectDiscoveryId
} from "../../store/reducers";
import { connect } from "react-redux";
import Permissions from "../../utils/permissions";
import { selectRegisterInterestFormPlacement } from "../../store/selectors/config";
import { getCheckpointForFormPlacement } from "../../Pages/Discovery/RegisterInterestPrompt";
import RegisterInterestButton from "./RegisterInterestButton";

const GoToKPIChallengeSummary = ({
  history,
  discoveryId,
  canSeeLeadGeneration,
  formPlacement,
  isRegistered
}) => {
  const reviewAndShare = s(
    "discovery.challenges.page.button2",
    "Review summary"
  );
  const isRegisterInterestButton =
    canSeeLeadGeneration &&
    getCheckpointForFormPlacement(formPlacement) === "/select-challenges" &&
    !isRegistered;

  const onClick = () => {
    history.push({ pathname: `/discoveries/${discoveryId}/challenge-summary` });
  };

  return isRegisterInterestButton ? (
    <OnlyIfUserCanAccessDiscoveryPath path={"challenge-summary"}>
      <RegisterInterestButton onClick={onClick} />
    </OnlyIfUserCanAccessDiscoveryPath>
  ) : (
    <OnlyIfUserCanAccessDiscoveryPath path={"challenge-summary"}>
      <NewButton
        onClick={onClick}
        type={"alternate"}
        data-cy={"review-and-share-button"}
      >
        {reviewAndShare}
      </NewButton>
    </OnlyIfUserCanAccessDiscoveryPath>
  );
};

const mapStateToProps = (state) => ({
  discoveryId: selectDiscoveryId(state),
  canSeeLeadGeneration: hasPermission(state, Permissions.SEE_LEAD_GENERATION),
  isRegistered: isDiscoveryRegisterInterestComplete(state),
  formPlacement: selectRegisterInterestFormPlacement(state)
});

export default compose(
  withRouter,
  connect(mapStateToProps)
)(GoToKPIChallengeSummary);
